import React, { useState } from "react";
import LazyUpdateThumb from "./LazyUpdateThumb";
import Pagination from "../Pagination";
import Constants from "../../Constants";
import { Link } from "react-router-dom";
import { useEffect } from "react";
const allYears = (filter, isNetwork, currentSite) => {
  let ret = [];
  let start = !isNetwork
    ? `${Constants.HOME}${filter}`
    : `${Constants.HOME}${currentSite}${filter}`;

  ret.push(
    <Link to={`${start}/all`} className="item" key={`yearsort-all`}>
      All Years
    </Link>,
  );

  const currentYear = new Date().getFullYear();
  for (let i = currentYear; i >= 2000; i--) {
    ret.push(
      <Link to={`${start}/${i}`} className="item" key={`yearsort-${i}`}>
        {i}
      </Link>,
    );
  }
  return ret;
};
const GeneralUpdates = ({
  label1,
  label2,
  updates,
  maxPages,
  path,
  currentSite,
  year,
  filter,
  isNetwork,
}) => {
  const [openSort, setOpenSort] = useState(false);
  const [openYear, setOpenYear] = useState(false);
  useEffect(() => {
    setOpenSort(false);
    setOpenYear(false);
  }, [year, filter]);
  return (
    <div className="section">
      <div className="container">
        <div className="heading">
          <h2 className="title">
            <strong>{label1}</strong> {label2}
          </h2>
          <div className="section_sorting">
            <div className={openSort ? "sorting_wrap open" : "sorting_wrap"}>
              <button
                type="button"
                className="sorting_button"
                onClick={() => setOpenSort((prev) => !prev)}
              >
                <span>{Constants.SORT[filter]}</span>
                <i className="icon-arrow-down"></i>
              </button>

              <div className="sorting_dropdown">
                {Object.keys(Constants.SORT)
                  .filter((key) => key !== filter)
                  .map((option) => (
                    <Link
                      to={`${Constants.HOME}${currentSite}${option}/${year}`}
                      className="item"
                      key={`sortto-${option}`}
                    >
                      {Constants.SORT[option]}
                    </Link>
                  ))}
              </div>
            </div>
            <div className={openYear ? "sorting_wrap open" : "sorting_wrap"}>
              <button
                type="button"
                className="sorting_button"
                onClick={() => setOpenYear((prev) => !prev)}
              >
                <span>{year === "all" ? "All Years" : year}</span>
                <i className="icon-arrow-down"></i>
              </button>
              <div className="sorting_dropdown">
                {allYears(filter, isNetwork, currentSite)}
              </div>
            </div>
          </div>
        </div>

        <div className="thumbs archive">
          {updates.map((item) => (
            <LazyUpdateThumb item={item} key={`gu${item.id}`} />
          ))}
        </div>
        <Pagination maxPages={maxPages} path={path} />
      </div>
    </div>
  );
};

export default GeneralUpdates;
